export const getStat = (team, name: string): number => team?.statistics?.find((s) => s.name === name)?.value ?? 0;
